const NOTIFICATIONS_UPDATED = "notifications:updated";

export const notifyBadgeRefresh = () => {
  window.dispatchEvent(new Event(NOTIFICATIONS_UPDATED));
};

export const onBadgeRefresh = (handler) => {
  window.addEventListener(NOTIFICATIONS_UPDATED, handler);
  return () => window.removeEventListener(NOTIFICATIONS_UPDATED, handler);
};
